export default function Spinner({ size = 'md', className = '' }) {
  const sizes = { sm: 'h-4 w-4', md: 'h-8 w-8', lg: 'h-12 w-12' }
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg className={`animate-spin ${sizes[size]} text-red-500`} viewBox="0 0 24 24" fill="none">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
    </div>
  )
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="lg" />
        <p className="text-sm text-zinc-500 animate-pulse">Loading...</p>
      </div>
    </div>
  )
}

export function SkeletonPost() {
  return (
    <div className="bg-zinc-900/40 rounded-2xl border border-zinc-800/20 p-5 animate-pulse">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-zinc-800" />
        <div className="space-y-1.5 flex-1">
          <div className="h-3.5 w-28 bg-zinc-800 rounded" />
          <div className="h-2.5 w-20 bg-zinc-800/50 rounded" />
        </div>
      </div>
      <div className="space-y-2 mb-3">
        <div className="h-3 w-full bg-zinc-800/40 rounded" />
        <div className="h-3 w-3/4 bg-zinc-800/40 rounded" />
      </div>
      <div className="h-48 w-full bg-zinc-800/30 rounded-xl" />
      <div className="flex gap-4 pt-3">
        <div className="h-3.5 w-10 bg-zinc-800/40 rounded" />
        <div className="h-3.5 w-10 bg-zinc-800/40 rounded" />
        <div className="h-3.5 w-10 bg-zinc-800/40 rounded" />
      </div>
    </div>
  )
}

export function SkeletonProfile() {
  return (
    <div className="animate-pulse">
      <div className="h-48 bg-zinc-800 rounded-2xl mb-4" />
      <div className="flex items-end -mt-16 ml-6 gap-4">
        <div className="w-28 h-28 rounded-3xl bg-zinc-700 border-4 border-zinc-900" />
        <div className="space-y-2 pb-2">
          <div className="h-5 w-32 bg-zinc-800 rounded" />
          <div className="h-3 w-24 bg-zinc-800/60 rounded" />
        </div>
      </div>
    </div>
  )
}
